import { useContext } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Box, Drawer, Hidden } from "@mui/material";
import { styled } from "@mui/material/styles";
import SidebarMenu from "./SidebarMenu";
import { SidebarContext } from "../../../contexts/SidebarContext";
import Logo from "../../../shared/components/logo";

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
    width: ${theme.sidebar.width};
    color: ${theme.sidebar.textColor};
    // background: ${theme.sidebar.background};
    // box-shadow: ${theme.sidebar.boxShadow};
    height: 85%;
    overflow-y: hidden;
    display: flex !important;
    align-items: center;
    bottom: 0;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
      position: fixed;
      z-index: 10;
    }
`
);

const SidebarWrapperCollapsed = styled(Box)(
  ({ theme }) => `
    // width: ${theme.sidebar.width};
    color: ${theme.sidebar.textColor};
    // background: ${theme.sidebar.background};
    // box-shadow: ${theme.sidebar.boxShadow};
    height: 85%;
    overflow-y: hidden;
    display: flex !important;
    align-items: center;
    bottom:0;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
      position: fixed;
      z-index: 10;
    }
`
);

const TopSection = styled(Box)(
  ({ theme }) => `
    display: flex;
    height: 88px;
    align-items: center;
    margin: 0 ${theme.spacing(2)} ${theme.spacing(2)};
    border-bottom: solid 1px var(--zs-border) ;
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();

  // useQuery("properties/my");
  // useMutation();

  // useEffect(() => {
  //   fetchData();
  // }, []);

  // const handleLogout = async () => {
  //   let response = await modifyData(`/user/logout`, "post");
  //   if (response) {
  //     window.location.href = "/login";
  //     clearLocalStorageData();
  //   }
  // };

  return (
    <>
      <Hidden lgDown>
        <SidebarWrapperCollapsed>
          {/* <SidebarMenu userData={(permissions as any)?.data} /> */}
          <SidebarMenu userData={null} />
          {/* <SidebarFooter onLogout={handleLogout} /> */}
        </SidebarWrapperCollapsed>
      </Hidden>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggle}
          onClose={closeSidebar}
          variant="temporary"
          elevation={9}
        >
          <SidebarWrapper>
            <Scrollbars autoHide>
              <TopSection>
                <Logo />
              </TopSection>
              <SidebarMenu userData={null} sidebarToggle={sidebarToggle} />
            </Scrollbars>
          </SidebarWrapper>
        </Drawer>
      </Hidden>
    </>
  );
}

export default Sidebar;
